export type ShelvingDimensions = {
  model: string;
  height: number;
  width: number;
  depth: number;
  shelfCount: number;
  sectionCount: number;
  sides: "single" | "double";
  frameState: "open" | "closed" | "outside";
};

export type RackType = "single" | "double";

export type ColumnType = "IPE180" | "IPE200" | "IPE220" | "IPE240" | "IPE300";
export type ArmType = "IPE100" | "IPE120" | "IPE140" | "IPE160";
export type ColumnCoating = "RAL 5019 Blue" | "Hot Dipped Galvanized";
export type ArmCoating = "RAL2008 Orange" | "Hot Dipped Galvanized";

export interface RackConfiguration {
  rackType: RackType;
  columnType: ColumnType;
  armType: ArmType;
  columnHeight: number;
  armLength: number;
  numberOfArmLevels: number;
  numberOfBays: number;
  clearanceTopLevel: number;
  bayWidth: number;
  columnCoating: ColumnCoating;
  armCoating: ArmCoating;
}

export const IPE_DIMENSIONS: Record<string, { width: number; height: number }> = {
  IPE100: { width: 55,  height: 100 },
  IPE120: { width: 64,  height: 120 },
  IPE140: { width: 73,  height: 140 },
  IPE160: { width: 82,  height: 160 },
  IPE180: { width: 91,  height: 180 },
  IPE200: { width: 100, height: 200 },
  IPE220: { width: 110, height: 220 },
  IPE240: { width: 120, height: 240 },
  IPE300: { width: 150, height: 300 },
};

export interface RackDimensions {
  columnWidth: number;
  columnDepth: number;
  armWidth: number;
  armHeight: number;
  spacing: number;
}
